'use client'

import { useMemo } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'
import { adaptProperties } from '@/screens/Product/model/common/adaptProperties'
import { getIsShowRustoreBlock } from '@/screens/Product/model/common/getIsShowRustoreBlock'

import { ProductGuarantee } from '../../ui/product-main/product-panel/components/product-guarantee/ProductGuarantee'
import cl from '../../ui/product-main/product-panel/components/product-parameters/product-parameters.module.scss'
import { ProductSpecsPanel } from '../../ui/product-main/product-panel/components/product-specs-panel/ProductSpecsPanel'

import { DiscountProductConditionSpecsPanel } from './discount-product-condition-specs'

export const DiscountProductParameters = (): JSX.Element => {
	const { product, conditionSpecs, discountKod } = useProduct()
	const showRustoreBlock = getIsShowRustoreBlock(product.SECTION_CODE, product.KOD)

	const productProperties = useMemo(() => {
		const adapted = adaptProperties(product.PROPERTIES)

		if (!discountKod) return adapted

		// ProductSpecsPanel показывает первые 4 — код должен быть последним видимым (index 3)
		return [...adapted.slice(0, 3), { name: `Код товара`, value: discountKod }, ...adapted.slice(3)]
	}, [discountKod, product.PROPERTIES])

	const hasSpecs = productProperties.length > 0
	const hasConditionSpecs = Boolean(conditionSpecs?.condition || conditionSpecs?.batterySize || conditionSpecs?.bundle)

	return (
		<div className={cl.stickyPannel}>
			{showRustoreBlock && (
				<div className={cl.subInfoPanel}>
					<ProductGuarantee className={cl.subInfoPanelItem} />
				</div>
			)}
			{hasConditionSpecs && conditionSpecs && <DiscountProductConditionSpecsPanel specs={conditionSpecs} />}
			{hasSpecs && <ProductSpecsPanel items={productProperties} />}
		</div>
	)
}
